import { connect } from "react-redux";
import DealerWalletListingApproval from "./Listing";
import { bindActionCreators } from "redux";
import {walletListingDealerApproval} from "../../../../services/redux/Wallet/action";

const mapStateToProps = (state) => ({
    listing : state.Wallet.dealerPaymentRequestApproval,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        walletListingDealerApproval
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DealerWalletListingApproval);